// Label & warna status pesanan untuk pembeli di HP (papan B6 Detail Pesanan, B7 Pesanan Saya). Aturan sistem 7 (Haryanto 25/10/2026):
// Menunggu Bayar = "Belum Dibayar". Ongkir pending = "Menunggu Konfirmasi Ongkir" (Aturan 3). Admin memakai STATUS_LABEL sendiri.
const GELAP = "gelap", ABU = "abu", HIJAU = "hijau", MERAH = "merah";
export const LUNAS = ["DIPROSES", "DIBAYAR", "DIKEMAS", "DIKIRIM", "SELESAI"];
export const BATAL = ["BATAL", "DIBATALKAN"];

export function lencanaStatus(o) {
  if (o.status === "MENUNGGU_BAYAR") return o.ongkir_pending ? ["Menunggu Konfirmasi Ongkir", GELAP] : ["Belum Dibayar", GELAP];
  if (o.status === "MENUNGGU_KONFIRMASI") return ["Menunggu Konfirmasi", ABU];
  if (o.status === "DIKIRIM") return ["Dikirim", ABU];
  if (o.status === "SELESAI") return ["Selesai", HIJAU];
  if (BATAL.includes(o.status)) return ["Dibatalkan", MERAH];
  return ["Diproses", ABU];
}

// Tahap papan B6 (Bayar / Diproses / Dikirim / Selesai) → indeks tahap sekarang; null = dibatalkan (tanpa bar)
export function tahapKini(o) {
  if (BATAL.includes(o.status)) return null;
  if (o.status === "SELESAI") return 3;
  if (o.status === "DIKIRIM") return 2;
  if (LUNAS.includes(o.status)) return 1;
  return 0;
}

// Ringkasan isi pesanan: "Seal PET 87mm dan 2 produk lain", total pcs, foto produk pertama
export function isiRingkas(o) {
  const items = o.items || [];
  const pertama = items[0] || {};
  const nama = pertama.nama_produk || "Pesanan";
  return {
    produk: items.length > 1 ? `${nama} dan ${items.length - 1} produk lain` : nama,
    pcs: items.reduce((t, it) => t + (Number(it.qty_pcs) || 0), 0),
    thumb: (items.find((it) => it.thumb) || {}).thumb || "",
  };
}
